import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BrandIntro from './components/BrandIntro';
import Testimonials from './components/Testimonials';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 吃瓜视频 | 全网独家吃瓜爆料视频平台';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        '关于吃瓜视频 - 国内领先的娱乐八卦视频资讯平台。每日更新网红翻车、明星八卦、热门爆料视频，免费吃瓜视频下载观看。千万用户真实口碑见证，吃瓜吃到饱！'
      );
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <BrandIntro />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}